import { useState } from "react"
import { LessonComp } from "../components/lessonComp"
import { AssementComp } from "../components/assessmentComp"
import { GridLayout, HorizontalPageLayout } from "../components/layout"

export function Quiz({pageSwap}) {
    
    return (
        <HorizontalPageLayout className={`assesment-page page-in-animation ${pageSwap && "page-out-animation"}`} style={{alignItems:"unset"}}>
            <AssementComp  />
        </HorizontalPageLayout>
    )
}